import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { PermissionEditService } from './permission-edit.service';
import { GenericDialogService } from '../generic-dialog/generic-dialog.service';
import { PermissionPickerComponent } from './permission-picker.component';
import { AuthService, PermissionHandler } from 'app/auth/auth.service';

@Component({
  selector: 'app-permission-edit',
  templateUrl: './permission-edit.component.html',
  styleUrl: './permission-edit.component.scss',
})
export class PermissionEditComponent implements OnDestroy, AfterViewInit {
  @Input() style: string = '';
  @HostBinding('class.d-none') hideHost: boolean = true;
  notViewable: boolean = true;
  customFallback: boolean = true;
  missingPermissionNames: string;

  @Input() set permissionName(name: string) {
    this._permissionName = name;
    this.resolveAccess([name]);
  }

  get permissionName(): string {
    return this._permissionName;
  }

  @Input() set permissionNames(names: string[]) {
    this._permissionName = names[0];
    this.resolveAccess(names);
  }

  @Input() set skip(val: boolean) {
    this._skip = val;
    if (val) {
      this.hideHost = this.notViewable = false;
    }
  }

  get skip(): boolean {
    return this._skip;
  }

  @Input() set showFallback(val: boolean | string) {
    val = val === '' ? true : (val as boolean);
    this._showFallback = val;
    if (val) {
      this.hideHost = false;
    }
  }

  get showFallback(): boolean {
    return this._showFallback;
  }

  private _permissionName: string;
  private _skip: boolean = false;
  private _showFallback: boolean = false;
  private subs = new Subscription();

  constructor(
    public permissionEdit: PermissionEditService,
    private dialog: GenericDialogService,
    private authService: AuthService,
    private elRef: ElementRef
  ) {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngAfterViewInit(): void {
    if (this.elRef && this.elRef.nativeElement.querySelector('fallback-content')) {
      this._showFallback = true;
      setTimeout(() => (this.hideHost = false));
    } else {
      setTimeout(() => (this.customFallback = false));
    }
  }

  edit(): void {
    const ref = this.dialog.open(PermissionPickerComponent);
    ref.componentInstance.initPermissionName(this.permissionName);
  }

  private resolveAccess(permissionNames: string[]): void {
    this.subs.add(
      this.authService.permissions.subscribe((handler) => {
        this.notViewable = !this.skip && this.hasMissingPermissions(handler, permissionNames);
        this.hideHost = !this._showFallback && this.notViewable;
      })
    );
  }

  private hasMissingPermissions(handler: PermissionHandler, names: string[]): boolean {
    const missingPermissionNames = [];
    for (const name of names) {
      if (!handler.has(name)) {
        missingPermissionNames.push(name);
      }
    }
    if (missingPermissionNames.length) {
      this.missingPermissionNames = missingPermissionNames.join(', ');
    }
    return missingPermissionNames.length > 0;
  }
}
